<template>
	<ConsoleEventArg renderAs="ArgValue" :serialized="value" :value="data" :class="{'break-all': wrap}" :wrap="wrap" />
</template>

<script>
export default {
	name: 'ArgSerialized',
	props: {
		value: {
			validator(value) {
				if (typeof value !== 'object') {
					// eslint-disable-next-line no-console
					console.warn('value is not object')
					return false
				}
				if (value.version !== '1.0.0') {
					// eslint-disable-next-line no-console
					console.warn('value.version is not 1.0.0')
					return false
				}
				if (!Array.isArray(value.serialized)) {
					// eslint-disable-next-line no-console
					console.warn('value.serialized is not array')
					return false
				}
				return true
			},
		},
		wrap: Boolean,
	},
	computed: {
		data() {
			return this.value?.serialized?.[0]
		},
	},
}
</script>
